import { INTEREST_SET_STATISTIC } from './actionTypes';

const defaultState = {
  statistic: [],
};

export function interest(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case INTEREST_SET_STATISTIC:
      return { ...state, statistic: payload };

    default:
      return state;
  }
}
